// buttons/button-factory.js
export default class ButtonFactory {
	static createButton(ButtonClass) {
		return {
			text: ButtonClass.buttonText, // statická property třídy
			onAction: (editor) => {
				const button = new ButtonClass(editor);
				return button.handleClick();
			}
		};
	}
}